import * as React from 'react';
const SvgSatsPrideLight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={99} height={29} fill="none">
    <path
      fill="url(#sats-pride-light_svg__a)"
      d="M70.539 13.766c8.407 0 15.107 6.586 15.107 14.57q0 .183-.007.373h2.136l.004-.374c0-9.08-7.48-16.468-16.795-16.696l-.445-.006q-.762 0-1.51.063v2.142q.745-.072 1.51-.072"
    />
    <path
      fill="url(#sats-pride-light_svg__b)"
      d="M70.54 11.635c9.546 0 17.17 7.48 17.17 16.568q0 .254-.008.505h2.134l.001-.022.006-.483c0-10.167-8.374-18.44-18.805-18.695l-.499-.006q-.762 0-1.51.056v2.14a18 18 0 0 1 1.51-.063"
    />
    <path
      fill="url(#sats-pride-light_svg__c)"
      d="M70.54 9.504c10.686 0 19.233 8.376 19.233 18.567q0 .318-.011.634h2.134l.003-.1.008-.534c0-11.254-9.27-20.41-20.816-20.694l-.551-.007c-.514 0-1.003.006-1.508.04V9.55c.504-.038.993-.045 1.508-.045"
    />
    <path
      fill="url(#sats-pride-light_svg__d)"
      d="M70.539 7.372c11.827 0 21.298 9.272 21.298 20.567q0 .383-.014.762h2.134l.005-.176.008-.586c0-12.34-10.165-22.382-22.826-22.692l-.605-.008q-.764 0-1.517.047l.006 2.14c.501-.033 1-.054 1.511-.054"
    />
    <path
      fill="url(#sats-pride-light_svg__e)"
      d="M70.54 5.24c12.966 0 23.36 10.167 23.36 22.567q0 .45-.017.896h2.134l.008-.258.009-.638c0-13.428-11.06-24.354-24.837-24.692l-.658-.008c-.513 0-1.018.016-1.523.045l.008 2.132a24 24 0 0 1 1.515-.043"
    />
    <path
      fill="url(#sats-pride-light_svg__f)"
      d="M70.54 3.106c14.105 0 25.424 11.198 25.424 24.701q0 .45-.017.895h2.135l.006-.205.01-.69c0-14.515-11.956-26.46-26.848-26.825l-.71-.009c-.51 0-1.02.005-1.523.031v2.137a27 27 0 0 1 1.523-.035"
    />
    <path
      fill="#fff"
      d="M9.267 28.714c-3.902 0-6.78-1.504-8.38-3.647l4.382-3.358a5.66 5.66 0 0 0 4.254 1.951c1.951 0 2.783-.832 2.783-2.047 0-.864-.64-1.503-1.663-2.367L9.17 17.998c-1.535-1.311-2.815-3.038-2.815-5.277 0-3.999 3.39-7.293 8.54-7.293 3.871 0 6.43 1.631 7.453 3.262l-4.414 3.327c-1.055-1.056-2.303-1.535-3.518-1.535-1.44 0-2.24.671-2.24 1.759 0 .896.768 1.567 1.632 2.303l1.504 1.28c1.47 1.247 2.846 3.006 2.846 5.181 0 4.286-2.942 7.709-8.892 7.709M30.983 5.876h7.708v22.39H33.51v-4.542h-7.26l-2.527 4.542h-6.174zM29.095 18.67h4.414v-7.932zM42.949 28.266 47.81 10.93h-5.917l1.44-5.054h17.272l-1.44 5.054h-5.533l-4.926 17.336zM63.869 28.714c-3.903 0-6.782-1.504-8.38-3.647l4.381-3.358a5.66 5.66 0 0 0 4.254 1.951c1.952 0 2.783-.832 2.783-2.047 0-.864-.64-1.503-1.663-2.367l-1.471-1.248c-1.536-1.311-2.815-3.038-2.815-5.277 0-3.999 3.39-7.293 8.54-7.293 3.87 0 6.43 1.631 7.453 3.262l-4.414 3.327c-1.056-1.056-2.303-1.535-3.519-1.535-1.44 0-2.239.671-2.239 1.759 0 .896.768 1.567 1.632 2.303l1.503 1.28c1.471 1.247 2.847 3.006 2.847 5.181 0 4.286-2.943 7.709-8.892 7.709"
    />
    <defs>
      <linearGradient
        id="sats-pride-light_svg__a"
        x1={69.03}
        x2={78.116}
        y1={20.429}
        y2={20.429}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#502E91" stopOpacity={0} />
        <stop offset={1} stopColor="#502E91" />
      </linearGradient>
      <linearGradient
        id="sats-pride-light_svg__b"
        x1={69.03}
        x2={78.088}
        y1={19.298}
        y2={19.298}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#336FE2" stopOpacity={0} />
        <stop offset={1} stopColor="#336FE2" />
      </linearGradient>
      <linearGradient
        id="sats-pride-light_svg__c"
        x1={69.032}
        x2={79.066}
        y1={18.168}
        y2={18.168}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#55A17B" stopOpacity={0} />
        <stop offset={1} stopColor="#55A17B" />
      </linearGradient>
      <linearGradient
        id="sats-pride-light_svg__d"
        x1={69.022}
        x2={78.088}
        y1={17.036}
        y2={17.036}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFC100" stopOpacity={0} />
        <stop offset={1} stopColor="#FFC100" />
      </linearGradient>
      <linearGradient
        id="sats-pride-light_svg__e"
        x1={69.016}
        x2={78.144}
        y1={15.905}
        y2={15.905}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF621D" stopOpacity={0} />
        <stop offset={1} stopColor="#FF621D" />
      </linearGradient>
      <linearGradient
        id="sats-pride-light_svg__f"
        x1={69.017}
        x2={78.116}
        y1={14.905}
        y2={14.905}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C2102A" stopOpacity={0} />
        <stop offset={1} stopColor="#C2102A" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgSatsPrideLight;
